/**
 * Seconds as "1h 30m", or "45m" under an hour.
 *
 * Rounded to whole minutes first and split second. The other way round —
 * whole hours, then the remainder rounded — turned 1h 59m 30s into
 * "1h 60m" on both screens that carried a copy of it.
 */
export function hoursAndMinutes(seconds: number): string {
  const total = Math.round(seconds / 60);
  const h = Math.floor(total / 60);
  const m = total % 60;
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
}
